import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "md:min-h-screen" }
const _hoisted_2 = { class: "container mx-auto px-8 py-6 hidden md:block" }
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "flex flex-col gap-4" }
const _hoisted_5 = { class: "flex items-center gap-6" }
const _hoisted_6 = { class: "flex flex-wrap gap-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex items-center gap-6" }
const _hoisted_9 = { class: "flex flex-wrap gap-4" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex items-center gap-6" }
const _hoisted_12 = { class: "flex flex-wrap gap-4" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex items-center gap-6" }
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = { class: "flex items-center gap-6" }
const _hoisted_17 = { class: "relative flex-1 max-w-md" }
const _hoisted_18 = {
  key: 0,
  class: "flex flex-wrap gap-2 mt-6"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "flex items-center bg-blue-50 px-3 py-1 rounded-full text-sm text-blue-600"
}
const _hoisted_22 = {
  key: 1,
  class: "flex items-center bg-blue-50 px-3 py-1 rounded-full text-sm text-blue-600"
}
const _hoisted_23 = { class: "md:hidden left-0 right-0 px-4 py-3 flex justify-between items-center z-10 border-b border-gray-100" }
const _hoisted_24 = { class: "text-sm text-gray-600" }
const _hoisted_25 = { class: "container mx-auto px-8 py-6" }
const _hoisted_26 = { class: "grid grid-cols-2 md:grid-cols-4 gap-6" }
const _hoisted_27 = { class: "relative aspect-square overflow-hidden rounded-t-lg" }
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = { class: "absolute inset-0 bg-black bg-opacity-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" }
const _hoisted_30 = { class: "p-4" }
const _hoisted_31 = { class: "text-lg font-medium mb-2" }
const _hoisted_32 = { class: "text-gray-600 text-sm mb-2 line-clamp-2" }
const _hoisted_33 = { class: "flex items-center justify-between" }
const _hoisted_34 = { class: "flex items-center space-x-2" }
const _hoisted_35 = {
  key: 0,
  class: "text-gray-400 text-sm line-through"
}
const _hoisted_36 = { class: "text-red-600 font-medium" }
const _hoisted_37 = { class: "flex items-center" }
const _hoisted_38 = { class: "ml-1 text-sm text-gray-600" }
const _hoisted_39 = { class: "container mx-auto px-8 py-8 flex justify-center items-center gap-2" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-hidden"
}
const _hoisted_44 = { class: "flex justify-between items-center px-4 py-4 border-b border-gray-100" }
const _hoisted_45 = { class: "h-[calc(100%-8rem)] overflow-y-auto px-4 py-4 pb-24" }
const _hoisted_46 = { class: "mb-6" }
const _hoisted_47 = { class: "relative" }
const _hoisted_48 = { class: "mb-6" }
const _hoisted_49 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "mb-6" }
const _hoisted_52 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "mb-6" }
const _hoisted_55 = { class: "grid grid-cols-2 gap-3 mb-3" }
const _hoisted_56 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_57 = ["onClick"]

import { ref, computed } from "vue";
// 导入路由相关
import { useRoute, useRouter } from 'vue-router';
// 导入响应式相关
import { watch } from 'vue';
// 商品s筛选
// const categories = [
//   "全部商品",
//   "自行车",
//   "运动装备",
//   "配饰",
//   "背包",
//   "运动服装",
// ];
// 当前页
import { getProductList } from '../api/product.js';

// 获取路径参数
interface RouteParams {
  type: string;
}

const itemsPerPage = 8;
// 总页数

export default /*@__PURE__*/_defineComponent({
  __name: 'product',
  setup(__props) {

const currentPage = ref(1);
// 搜索框
const searchQuery = ref("");
// 价格区间
const priceRange = ref({
  min: "",
  max: "",
});
// 选中的分类（多选，移动端和桌面端共用）
const selectedCategories = ref<string[]>([]);
// 选中的用途（多选，移动端和桌面端共用）
const selectedPurposes = ref<string[]>([]);
// 分类数据
const categories = [
  "头盔",
  "服饰",
  "山地车",
  "公路车",
  "折叠车",
  "儿童车",
  "骑行服",
  "骑行裤",
  "手套",
  "眼镜",
  "水壶",
  "车灯",
];
// 用途数据
const purposes = [
  "休闲骑行",
  "竞技比赛",
  "通勤代步",
  "越野探险",
  "健身运动",
  "亲子出行",
];
// 预设价格区间
const priceRanges = [
  { label: "100-500", min: 100, max: 500 },
  { label: "500-1000", min: 500, max: 1000 },
  { label: "1000-3000", min: 1000, max: 3000 },
  { label: "3000以上", min: 3000, max: 99999 },
];

// 导入产品数据API
const route = useRoute<RouteParams>();
const loading = ref(false);
const error = ref(null);

// 获取产品列表数据的函数
const fetchProducts = async (typeParam) => {
  loading.value = true;
  error.value = null;
  try {
    // 调用API获取产品列表，传入type参数
    const data = await getProductList(typeParam);
    products.value = data;
  } catch (err) {
    error.value = '获取产品列表失败';
    console.error('获取产品列表错误:', err);
  } finally {
    loading.value = false;
  }
};

// 商品列表响应式数据
const products = ref([]);

// 初始化加载产品数据
fetchProducts(route.query.type);

// 监听路由参数变化，当type参数改变时更新产品数据
watch(
  () => route.query.type,
  (newType) => {
    fetchProducts(newType);
  },
  { immediate: true }
);

// 过滤产品，使用统一的筛选条件
const filteredProducts = computed(() => {
  let result = [...products.value];
  
  // 分类筛选（多选）
  if (selectedCategories.value.length > 0) {
    result = result.filter((product) => {
      return selectedCategories.value.includes(product.category);
    });
  }
  
  // 用途筛选（多选）
  if (selectedPurposes.value.length > 0) {
    result = result.filter((product) => {
      return product.purposes && product.purposes.some(purpose => 
        selectedPurposes.value.includes(purpose)
      );
    });
  }
  
  // 搜索筛选
  if (searchQuery.value) {
    result = result.filter(
      (product) =>
        product.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        product.description
          .toLowerCase()
          .includes(searchQuery.value.toLowerCase()),
    );
  }
  
  // 价格区间筛选
  if (priceRange.value.min) {
    result = result.filter(
      (product) => {
        // 使用实际显示的价格（折扣价或原价）进行筛选
        const displayPrice = product.discountPrice && product.discountPrice > 0 && product.discountPrice < product.price ? product.discountPrice : product.price;
        return displayPrice >= Number(priceRange.value.min);
      },
    );
  }
  if (priceRange.value.max) {
    result = result.filter(
      (product) => {
        // 使用实际显示的价格（折扣价或原价）进行筛选
        const displayPrice = product.discountPrice && product.discountPrice > 0 && product.discountPrice < product.price ? product.discountPrice : product.price;
        return displayPrice <= Number(priceRange.value.max);
      },
    );
  }
  
  return result;
});
// 每页显示的产品数量
const totalPages = computed(() =>
  Math.ceil(filteredProducts.value.length / itemsPerPage),
);
// 展示的商品数据
const displayProducts = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return filteredProducts.value.slice(start, end);
});

// 筛选面板控制
const showFilter = ref(false);
const toggleFilter = (value: boolean) => {
  showFilter.value = value;
  if (value) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
};
// 重置所有筛选条件
const resetFilters = () => {
  searchQuery.value = "";
  selectedCategories.value = [];
  selectedPurposes.value = [];
  priceRange.value = { min: "", max: "" };
  currentPage.value = 1;
};
// 应用筛选条件（移动端关闭筛选面板）
const applyFilters = () => {
  showFilter.value = false;
  currentPage.value = 1;
};
// 计算总商品数（共用）
const totalProducts = computed(() => filteredProducts.value.length);

// 移动端显示的商品数据
const currentProducts = computed(() => {
  const start = (currentPage.value - 1) * 6;
  const end = start + 6;
  return filteredProducts.value.slice(start, end);
});
const paginationPages = computed(() => {
  const pages = [];
  const total = totalPages.value;
  if (total <= 3) {
    for (let i = 1; i <= total; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1, 2, 3);
    if (total > 3) {
      pages.push("...");
      pages.push(total);
    }
  }
  return pages;
});
// 切换分类选择状态
const toggleCategory = (category: string) => {
  const index = selectedCategories.value.indexOf(category);
  if (index > -1) {
    selectedCategories.value.splice(index, 1);
  } else {
    selectedCategories.value.push(category);
  }
  currentPage.value = 1; // 切换筛选条件时重置到第一页
};

// 选择预设价格区间
const selectPriceRange = (range: {
  label: string;
  min: number;
  max: number;
}) => {
  priceRange.value.min = range.min.toString();
  priceRange.value.max = range.max === 99999 ? "" : range.max.toString();
  currentPage.value = 1; // 切换筛选条件时重置到第一页
};

// 检查价格区间是否被选中
const isSelectedPriceRange = (range: {
  label: string;
  min: number;
  max: number;
}) => {
  const minMatch = priceRange.value.min === range.min.toString();
  const maxMatch = 
    range.max === 99999
      ? priceRange.value.max === ""
      : priceRange.value.max === range.max.toString();
  return minMatch && maxMatch;
};

// 切换用途选择状态
const togglePurpose = (purpose: string) => {
  const index = selectedPurposes.value.indexOf(purpose);
  if (index > -1) {
    selectedPurposes.value.splice(index, 1);
  } else {
    selectedPurposes.value.push(purpose);
  }
  currentPage.value = 1; // 切换筛选条件时重置到第一页
};

// 清除单个筛选条件的辅助方法
const clearSelectedCategory = (category: string) => {
  const index = selectedCategories.value.indexOf(category);
  if (index > -1) {
    selectedCategories.value.splice(index, 1);
  }
  currentPage.value = 1;
};

const clearSelectedPurpose = (purpose: string) => {
  const index = selectedPurposes.value.indexOf(purpose);
  if (index > -1) {
    selectedPurposes.value.splice(index, 1);
  }
  currentPage.value = 1;
};

const clearPriceRange = () => {
  priceRange.value = { min: "", max: "" };
  currentPage.value = 1;
};

const clearSearchQuery = () => {
  searchQuery.value = ""; 
  currentPage.value = 1;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex items-center text-sm text-gray-500 mb-6" }, [
        _createElementVNode("span", { class: "cursor-pointer hover:text-blue-600" }, "首页"),
        _createElementVNode("i", { class: "fas fa-chevron-right mx-2 text-xs" }),
        _createElementVNode("span", { class: "cursor-pointer hover:text-blue-600" }, "商品列表")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-gray-600 w-30" }, "商品分类:", -1)),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (category) => {
                return _createElementVNode("button", {
                  key: category,
                  class: _normalizeClass([{ 'bg-blue-50 text-blue-600': selectedCategories.value.includes(category) }, "px-4 py-2 rounded-button text-sm hover:bg-blue-50 cursor-pointer whitespace-nowrap"]),
                  onClick: ($event: any) => (toggleCategory(category))
                }, _toDisplayString(category), 11, _hoisted_7)
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-gray-600 w-30" }, "使用场景:", -1)),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(purposes, (purpose) => {
                return _createElementVNode("button", {
                  key: purpose,
                  class: _normalizeClass([{ 'bg-blue-50 text-blue-600': selectedPurposes.value.includes(purpose) }, "px-4 py-2 rounded-button text-sm hover:bg-blue-50 cursor-pointer whitespace-nowrap"]),
                  onClick: ($event: any) => (togglePurpose(purpose))
                }, _toDisplayString(purpose), 11, _hoisted_10)
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-gray-600 w-30" }, "价格区间:", -1)),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(priceRanges, (range) => {
                return _createElementVNode("button", {
                  key: range.label,
                  class: _normalizeClass([{ 'bg-blue-50 text-blue-600': isSelectedPriceRange(range) }, "px-4 py-2 rounded-button text-sm hover:bg-blue-50 cursor-pointer whitespace-nowrap"]),
                  onClick: ($event: any) => (selectPriceRange(range))
                }, _toDisplayString(range.label), 11, _hoisted_13)
              }), 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-gray-600 w-30" }, "自定义价格:", -1)),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((priceRange.value.min) = $event)),
              type: "text",
              class: "w-24 px-3 py-2 border rounded-lg text-sm",
              placeholder: "最低价"
            }, null, 512), [
              [_vModelText, priceRange.value.min]
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("span", null, "-", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((priceRange.value.max) = $event)),
              type: "text",
              class: "w-24 px-3 py-2 border rounded-lg text-sm",
              placeholder: "最高价"
            }, null, 512), [
              [_vModelText, priceRange.value.max]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-gray-600 w-30" }, "搜索:", -1)),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
              type: "text",
              class: "w-full pl-10 pr-4 py-2 border rounded-lg text-sm",
              placeholder: "搜索商品"
            }, null, 512), [
              [_vModelText, searchQuery.value]
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" }, null, -1))
          ])
        ])
      ]),
      (selectedCategories.value.length > 0 || selectedPurposes.value.length > 0 || searchQuery.value || priceRange.value.min || priceRange.value.max)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCategories.value, (category) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `category-${category}`,
                class: "flex items-center bg-blue-50 px-3 py-1 rounded-full text-sm text-blue-600"
              }, [
                _createElementVNode("span", null, "分类: " + _toDisplayString(category), 1),
                _createElementVNode("i", {
                  class: "fas fa-times ml-2 cursor-pointer",
                  onClick: ($event: any) => (clearSelectedCategory(category))
                }, null, 8, _hoisted_19)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPurposes.value, (purpose) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `purpose-${purpose}`,
                class: "flex items-center bg-blue-50 px-3 py-1 rounded-full text-sm text-blue-600"
              }, [
                _createElementVNode("span", null, "场景: " + _toDisplayString(purpose), 1),
                _createElementVNode("i", {
                  class: "fas fa-times ml-2 cursor-pointer",
                  onClick: ($event: any) => (clearSelectedPurpose(purpose))
                }, null, 8, _hoisted_20)
              ]))
            }), 128)),
            (searchQuery.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("span", null, "搜索: " + _toDisplayString(searchQuery.value), 1),
                  _createElementVNode("i", {
                    class: "fas fa-times ml-2 cursor-pointer",
                    onClick: clearSearchQuery
                  })
                ]))
              : _createCommentVNode("", true),
            (priceRange.value.min || priceRange.value.max)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("span", null, "价格: " + _toDisplayString(priceRange.value.min || '0') + "-" + _toDisplayString(priceRange.value.max || '不限'), 1),
                  _createElementVNode("i", {
                    class: "fas fa-times ml-2 cursor-pointer",
                    onClick: clearPriceRange
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: resetFilters,
              class: "flex items-center bg-gray-100 px-3 py-1 rounded-full text-sm text-gray-600 hover:bg-gray-200"
            }, _cache[18] || (_cache[18] = [
              _createElementVNode("i", { class: "fas fa-times mr-1" }, null, -1),
              _createElementVNode("span", null, "清除全部", -1)
            ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleFilter(true))),
        class: "flex items-center space-x-2 px-3 py-2 bg-white rounded-lg border border-gray-200 cursor-pointer !rounded-button"
      }, _cache[20] || (_cache[20] = [
        _createElementVNode("i", { class: "fas fa-filter text-gray-600 text-sm" }, null, -1),
        _createElementVNode("span", { class: "text-sm text-gray-700" }, "筛选", -1)
      ])),
      _createElementVNode("span", _hoisted_24, "共 " + _toDisplayString(totalProducts.value) + " 件商品", 1)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayProducts.value, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            key: product.id,
            class: "group bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
          }, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("img", {
                src: product.image,
                alt: product.name,
                class: "w-full h-full object-cover object-top"
              }, null, 8, _hoisted_28),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_router_link, {
                  to: { path: `/product/${product.id}`, query: { type: _unref(route).query.type } },
                  class: "inline-block"
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createElementVNode("button", { class: "bg-white text-gray-800 px-6 py-2 rounded-button text-sm font-medium cursor-pointer whitespace-nowrap" }, " 查看详情 ", -1)
                  ])),
                  _: 2,
                  __: [21]
                }, 1032, ["to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("h3", _hoisted_31, _toDisplayString(product.name), 1),
              _createElementVNode("p", _hoisted_32, _toDisplayString(product.description), 1),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  (product.discountPrice && product.discountPrice > 0 && product.discountPrice < (product.price || 0))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, "¥" + _toDisplayString(product.price || 0), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_36, "¥" + _toDisplayString((product.discountPrice && product.discountPrice > 0 && product.discountPrice < (product.price || 0)) ? product.discountPrice : (product.price || 0)), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-star text-yellow-400" }, null, -1)),
                  _createElementVNode("span", _hoisted_38, _toDisplayString(product.rating), 1)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-button text-sm bg-gray-100 hover:bg-gray-200 cursor-pointer whitespace-nowrap",
        disabled: currentPage.value === 1,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (currentPage.value--))
      }, " 上一页 ", 8, _hoisted_40),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
        return (_openBlock(), _createElementBlock("button", {
          key: page,
          class: _normalizeClass([{ 'bg-blue-600 text-white': currentPage.value === page }, "w-10 h-10 rounded-button flex items-center justify-center text-sm hover:bg-gray-100 cursor-pointer whitespace-nowrap"]),
          onClick: ($event: any) => (currentPage.value = page)
        }, _toDisplayString(page), 11, _hoisted_41))
      }), 128)),
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-button text-sm bg-gray-100 hover:bg-gray-200 cursor-pointer whitespace-nowrap",
        disabled: currentPage.value === totalPages.value,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (currentPage.value++))
      }, " 下一页 ", 8, _hoisted_42)
    ]),
    (showFilter.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black bg-opacity-50",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleFilter(false)))
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["absolute right-0 top-0 h-full w-2/3 bg-white transform transition-transform duration-300", { 'translate-x-0': showFilter.value, 'translate-x-full': !showFilter.value }])
          }, [
            _createElementVNode("div", _hoisted_44, [
              _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, "筛选条件", -1)),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleFilter(false))),
                class: "p-2 cursor-pointer"
              }, _cache[23] || (_cache[23] = [
                _createElementVNode("i", { class: "fas fa-times text-gray-500" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((searchQuery).value = $event)),
                    type: "text",
                    placeholder: "搜索商品...",
                    class: "w-full pl-10 pr-10 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-blue-500"
                  }, null, 512), [
                    [_vModelText, searchQuery.value]
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" }, null, -1)),
                  (searchQuery.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: clearSearchQuery,
                        class: "absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                      }, _cache[25] || (_cache[25] = [
                        _createElementVNode("i", { class: "fas fa-times text-gray-400 text-sm" }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _cache[27] || (_cache[27] = _createElementVNode("h3", { class: "text-base font-medium text-gray-900 mb-3" }, "商品分类", -1)),
                _createElementVNode("div", _hoisted_49, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (category) => {
                    return _createElementVNode("button", {
                      key: category,
                      onClick: ($event: any) => (toggleCategory(category)),
                      class: _normalizeClass([{
                        'bg-blue-500 text-white border-blue-500': selectedCategories.value.includes(category),
                        'bg-white text-gray-700 border-gray-200': !selectedCategories.value.includes(category)
                        }, "px-3 py-2 border rounded-lg text-sm cursor-pointer !rounded-button"])
                    }, _toDisplayString(category), 11, _hoisted_50)
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _cache[28] || (_cache[28] = _createElementVNode("h3", { class: "text-base font-medium text-gray-900 mb-3" }, "用途分类", -1)),
                _createElementVNode("div", _hoisted_52, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(purposes, (purpose) => {
                    return _createElementVNode("button", {
                      key: purpose,
                      onClick: ($event: any) => (togglePurpose(purpose)),
                      class: _normalizeClass([{
                        'bg-blue-500 text-white border-blue-500': selectedPurposes.value.includes(purpose),
                        'bg-white text-gray-700 border-gray-200': !selectedPurposes.value.includes(purpose)
                        }, "px-3 py-2 border rounded-lg text-sm cursor-pointer !rounded-button"])
                    }, _toDisplayString(purpose), 11, _hoisted_53)
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "text-base font-medium text-gray-900 mb-3" }, "价格区间", -1)),
                _createElementVNode("div", _hoisted_55, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((priceRange.value.min) = $event)),
                    type: "number",
                    placeholder: "最低价",
                    class: "px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-blue-500"
                  }, null, 512), [
                    [_vModelText, priceRange.value.min]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((priceRange.value.max) = $event)),
                    type: "number",
                    placeholder: "最高价",
                    class: "px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-blue-500"
                  }, null, 512), [
                    [_vModelText, priceRange.value.max]
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(priceRanges, (range) => {
                    return _createElementVNode("button", {
                      key: range.label,
                      onClick: ($event: any) => (selectPriceRange(range)),
                      class: _normalizeClass([{
                        'bg-blue-500 text-white border-blue-500': isSelectedPriceRange(range),
                        'bg-white text-gray-700 border-gray-200': !isSelectedPriceRange(range)
                        }, "px-3 py-2 border rounded-lg text-sm cursor-pointer !rounded-button"])
                    }, _toDisplayString(range.label), 11, _hoisted_57)
                  }), 64))
                ])
              ])
            ]),
            _createElementVNode("div", { class: "border-t border-gray-100 px-4 py-4 absolute bottom-0 left-0 right-0 bg-white" }, [
              _createElementVNode("div", { class: "flex space-x-3" }, [
                _createElementVNode("button", {
                  onClick: resetFilters,
                  class: "flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg text-sm cursor-pointer !rounded-button"
                }, " 重置 "),
                _createElementVNode("button", {
                  onClick: applyFilters,
                  class: "flex-1 px-4 py-3 bg-blue-500 text-white rounded-lg text-sm cursor-pointer !rounded-button"
                }, " 确认 ")
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})